import { FC, useEffect } from 'react'
import { ScormIframeDialog } from 'modules/trainings/components/ScormIframeDialog/ScormIframeDialog'
import { useScormLaunch } from 'modules/trainings/hooks/ScormRegistration/useScormLaunch'

type Props = {
  trainingMembershipId: string
  isOpen: boolean
  onClose: () => void
}

export const ScormContent: FC<Props> = ({ trainingMembershipId, isOpen, onClose }) => {
  const { launchLink, error, launch, reset } = useScormLaunch({ trainingMembershipId })

  useEffect(() => {
    if (isOpen) {
      launch()
    } else {
      reset()
    }
  }, [isOpen, launch, reset])

  return <ScormIframeDialog isOpen={isOpen} onClose={onClose} src={launchLink} error={error} />
}
